import { dealCompareV2StorageKey } from '../../deal-compare/utils/deal-compare-storage-key';
import { LocalStorageService } from '../services/local-storage.service';
import { clearTabWorkspace, writeTabWorkspace } from './tab-workspace-storage';

/**
 * Forgets the browser state that belongs to the tenant being left. The tab keeps `keptWorkspaceId`
 * when the new tenant has that workspace too, so `/home` reopens it; otherwise the user picks one.
 */
export function clearTenantScopedStorage(keptWorkspaceId?: string): void {
  if (keptWorkspaceId) {
    // No assets: the claim is narrow until the workspace list of the new tenant lands.
    writeTabWorkspace({ workspaceId: keptWorkspaceId, assets: [] });
  } else {
    clearTabWorkspace();
  }

  LocalStorageService.remove(dealCompareV2StorageKey());
}
